// export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || 'https://api1.sanoft.com/api';
// export const BACKEND_URL = 'https://yscloud.in/backend/api';
export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-pos-legacy-uat.sanoft.com/api';

export const STORAGE_KEYS = {
  TOKEN: 'x-auth-token',
  USER_ID: 'x-auth-user-id',
  FIRST_NAME: 'x-first-name',
  LAST_NAME: 'x-last-name',
  USERNAME: 'x-username',
};

export const HEADERS = {
  AUTH: 'Authorization',
};

export const ROUTES = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  ANY: '/',
  CONSOLE: '/console',

  SHOPS: '/console/shops',
  NEW_SHOP: '/console/new-shop',
  EDIT_SHOP: '/console/shops/:shopId',
  REGISTRATION_KEY: '/console/registration-keys',
  NEW_REGISTRATION_KEY: '/console/registration-keys/new-key',
  EDIT_REGISTRATION_KEY: '/console/registration-keys/:keyId',
  CREATE_TERMINAL: '/console/shops/:shopId/terminal',
  PAGE_404: '/page-404',
  RENEWALS: '/console/renew-shops',
  WALLET_RECHARGE: '/console/dealers',
  DEALERS: '/console/dealers',
  DEALER_DETAILS: '/console/dealers/:dealerId',
};

export const GST_PREFERENCES = [
  { name: 'Non GST', id: 0 },
  { name: 'Excluding GST', id: 1 },
  { name: 'Including GST', id: 2 },
];

export const SUBSCRIPTION_OPTIONS = [
  { id: 32, key: 'sanoft-lite', name: "Sanoft lite - India", country: 'IN' },
  { id: 33, key: 'sanoft-pro', name: "Sanoft pro - India", country: 'IN' },
  { id: 34, key: 'sanoft-elite', name: "Sanoft elite - India", country: 'IN' },

  { id: 30, key: 'sanoft-lite', name: "Sanoft lite", },
  { id: 29, key: 'sanoft-pro', name: "Sanoft pro" },
  { id: 28, key: 'sanoft-elite', name: "Sanoft elite" },

  { id: 2, key: 'premium', name: "Premium" },
  { id: 4, key: 'standard', name: "Standard" },
  { id: 22, key: 'standard_12000_sales', name: "Standard 12000 Sales" },
  { id: 25, key: 'standard_18000_sales', name: "Standard 18000 Sales" },
  { id: 18, key: 'standard_24000_sales', name: "Standard 24000 Sales" },
  { id: 57, key: 'standard_7000_sales', name: "Standard 7000 Sales" },
];

export const DEALERS = {
  1: 'Scangle',
  2: 'Dubai',
  3: 'Oman',
  4: 'Sanoft',
  5: 'ALT',
  6: 'Dynamic',
  7: 'Saudi',
  8: 'Trass India',
  10: 'Yesweigh',
  11: 'Kraus',
  12: 'Elmass',
  13: 'HMS',
  14: 'Meezan',
  15: 'Venkatachalam',
  16: 'Victory',
  23: 'Bahrain',
};

export const CURRENCIES = ['₹', 'RO', 'AED', 'SAR'];

export const TERMINAL_TYPES = { pos_terminal: 'POS', ecs_terminal: 'ECS', pos_windows_terminal: 'POS Windows Terminal', pos_web_terminal: 'POS Web Terminal' };

export const ADDITIONAL_SALES = [
  { key: 'additional_sales_1', price: 0, sale_count: 1, count: 1 },
  { key: 'additional_sales_3000', price: 300, sale_count: 3000, count: 1 },
  { key: 'additional_sales_6000', price: 500, sale_count: 6000, count: 1 },
];

export const MONTHLY_SUB_PERIOD = 30;
export const YEARLY_SUB_PERIOD = 365;

export const COUNTRY_CONFIGRATION = {
  IN: { name: 'India', currency: '₹', code: 'IN', tax: 0.18 },
  SA: { name: 'Saudi Arabia', currency: 'SAR', code: 'SA', tax: 0 },
  OM: { name: 'Oman', currency: 'OMR', code: 'OM', tax: 0 },
  AE: { name: 'UAE', currency: 'AED', code: 'AE', tax: 0 },
  US: { name: 'US', currency: '$', code: 'US', tax: 0 },
};

export const REGISTRATION_KEY_COUNTRY_CHOICES = [
  { code: 'IN', name: 'India' },
  { code: 'US', name: 'US' },
  { code: 'AE', name: 'UAE' },
  { code: 'OM', name: 'Oman' },
  { code: 'SA', name: 'Saudi' },
  { code: 'MY', name: 'Malaysia' },
];

export const REGISTRATION_TYPE = {
  NEW: 'new-shop',
  TRIAL: 'trial-shop',
  RENEWAL: 'renew-shop',
};

export const ADDONS = {
  kot: 'kot_validity',
  image: 'image_support_validity',
  smart_scale: 'smart_scale_validity',
  bluetooth_scale: 'bluetooth_scale_validity',
  customer: 'customer_support_validity',
  external_api: 'quickbook_support_validity',
  pos_terminal: 'pos',
  ecs_terminal: 'ecs',
};

export const SHOP_STATUS_MAP = {
  active: 'Active',
  trial: 'Trial',
  'delete-requested': 'Delete Requested',
};

export const PAYMENT_MODES = [
  { value: 'CASH', label: 'Cash' },
  { value: 'BANK_TRANSFER', label: 'Bank Transfer' },
  { value: 'UPI', label: 'UPI' },
  { value: 'CHEQUE', label: 'Cheque' },
  { value: 'ONLINE', label: 'Online' },
  { value: 'OTHER', label: 'Other' },
];

